var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDownArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 87",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.12 72.12L20.21 43.21 49.12 14.3a8.375 8.375 0 002.452-5.92c0-4.593-3.779-8.372-8.372-8.372-2.22 0-4.351.883-5.92 2.452L2.45 37.29l.3-.29-.3.29-.29.3-.11.13-.16.18-.14.18c-.034.049-.07.096-.11.14l-.14.21-.09.12-.14.22-.08.13-.13.22s0 .09-.07.14a2.096 2.096 0 00-.11.21c-.033.072 0 .1-.08.16l-.09.19a1.44 1.44 0 01-.08.19 1.192 1.192 0 01-.07.17c0 .07 0 .14-.08.22v.15c0 .08 0 .16-.08.24a.706.706 0 010 .13c-.057.101-.12.198-.19.29a.482.482 0 000 .12 2.247 2.247 0 00-.07.28c.005.04.005.08 0 .12v.28a.547.547 0 000 .14 2.255 2.255 0 000 .26v1.64c-.005.08-.005.16 0 .24a1.206 1.206 0 000 .17 2.085 2.085 0 000 .25v.15a2.085 2.085 0 000 .25.752.752 0 000 .15c.015.081.035.161.06.24.025.079 0 .1 0 .16.028.068.051.139.07.21l.06.18c0 .06 0 .13.08.19.022.068.049.135.08.2l.06.16c.037.071.071.145.1.22a.814.814 0 01.07.13l.12.24.06.11.15.25a.44.44 0 00.05.09c.06.08.11.17.16.25l.06.09.18.24a.855.855 0 00.07.1l.27.33.18.2.15.16.26.27-.13-.13 34.98 34.81a8.375 8.375 0 005.92 2.452c4.593 0 8.372-3.779 8.372-8.372 0-2.22-.883-4.351-2.452-5.92z",
    fill: "#e61969",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrowLeft);
export default __webpack_public_path__ + "static/media/drop-down-arrow-left.04ae5ff24fe3a36ab278ec4def80afe1.svg";
export { ForwardRef as ReactComponent };